/**************************************************
 * Nombre:       Escoger_Fecha_Calendario_Cita
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, Skeleton, Tab} from "@mui/material";
import {LocalizationProvider, StaticDatePicker} from "@mui/x-date-pickers";
import {esES} from "@mui/x-date-pickers/locales";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import "dayjs/locale/es";
import {useEffect, useState} from "react";
import {TabContext, TabList, TabPanel} from "@mui/lab";
import {CalendarMonth, Timer} from '@mui/icons-material'
import {verificarDiaDisponible} from "../Funciones/verificarDiaDisponible";
import {verificarHoraDisponible} from "../Funciones/verificarHoraDisponible";
import {obtenerHorasDisponibles} from "../Funciones/obtenerHorasDisponibles";
import {theme} from "../../Tema";
import {where} from "firebase/firestore";
import {obtenerColWheres} from "../../Servicios/BD/obtenerColWheres";


const Escoger_Fecha_Calendario_Cita = ({diasDispo, setFecha, cerrar, coleccionCita}) => {
    const [fechaSelec, setFechaSelec] = useState(dayjs)
    const [horaSelec, setHoraSelec] = useState()
    const [tabSelec, setTabSelect] = useState(0)
    const [horasDisponibles, setHorasDisponibles] = useState([])
    const [horasNoDispo, setHoraNoDispo] = useState([])
    dayjs.locale('es')


    const escogerFecha = () => {

        let fecha_ = new Date(fechaSelec.valueOf()).setMinutes(horaSelec.hora)

        let hora = (horaSelec.jornada === 'am' ? horaSelec.hora : horaSelec.hora + 12)
        let fechaHora = new Date(fecha_).setHours(hora)
        let fechaMinutos = new Date(fechaHora).setMinutes(horaSelec.minutos)

        setFecha(fechaMinutos)
        cerrar()

    }

    useEffect(() => {

        let fecha = new Date(fechaSelec.valueOf())
        let fechaInicio = new Date(fecha).setHours(0)
        let fechaFin = new Date(fecha).setHours(23)

        let inicioNum = new Date(fechaInicio).getTime()
        let finNum = new Date(fechaFin).getTime()

        let w = [where('fechaCita', '>=', inicioNum), where('fechaCita', '<=', finNum)]
        obtenerColWheres({col: coleccionCita, wheres: w}).then((dox) => {
           // console.log(dox)
            if (dox.res){
                setHoraNoDispo(dox.data)
            }
        })


    }, [fechaSelec]);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <TabContext value={tabSelec}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{borderBottom: 1, borderColor: 'divider', justifyContent: 'center'}}>


                    <TabList onChange={(e, v) => setTabSelect(v)} aria-label="lab API tabs example">
                        <Tab icon={<CalendarMonth/>} iconPosition={'start'} disabled={tabSelec === 1} label="Fecha"
                             value={0}/>
                        <Tab icon={<Timer/>} iconPosition={'start'} label="Hora" value={1} disabled={tabSelec === 0}/>
                    </TabList>

                </Grid>

                <Grid
                    container
                    justifyContent={'center'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                >
                    <TabPanel value={0}>

                        {diasDispo.length <= 0 ?

                            <Skeleton variant={'rounded'} width={400} height={350}/> :

                            <>
                                <LocalizationProvider dateAdapter={AdapterDayjs}
                                                      localeText={esES.components.MuiLocalizationProvider.defaultProps.localeText}>
                                    <StaticDatePicker

                                        slotProps={{
                                            toolbar: {
                                                hidden: true,
                                            },
                                            actionBar: {
                                                actions: [''],
                                            },
                                        }}
                                        value={fechaSelec}
                                        onChange={(e) => setFechaSelec(e)}
                                        shouldDisableDate={(e) => verificarDiaDisponible(e, diasDispo)}
                                        defaultValue={dayjs()}
                                        disablePast
                                    />
                                </LocalizationProvider>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'flex-end'}>
                                    <Button
                                        onClick={() => {
                                            setTabSelect(1)
                                            setHorasDisponibles(obtenerHorasDisponibles(fechaSelec, diasDispo))
                                        }}
                                    >Siguiente</Button>
                                </Grid>

                            </>

                        }


                    </TabPanel>

                    <TabPanel value={1}>
                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                            spacing={2}
                        >

                            {horasDisponibles.map((it, index) => {
                                return (
                                    <Grid key={`w${index}`} container size={{xs: 4, sm: 4, md: 3}}>
                                        <Button
                                            onClick={() => setHoraSelec(it)}
                                            sx={{
                                                px: 0,
                                                pt: 1,
                                                backgroundColor: it === horaSelec ? '#00000050' : ''
                                            }}
                                            fullWidth disabled={verificarHoraDisponible(it, horasNoDispo)}
                                            variant={'outlined'}>{`${it.hora} : ${it.minutos < 10 ? '0' + it.minutos : it.minutos} ${it.jornada}`}</Button>
                                    </Grid>
                                )
                            })}

                            <Grid container size={{xs: 12, sm: 12, md: 6}} justifyContent={'flex-start'}>
                                <Button
                                    onClick={() => {
                                        setTabSelect(0)
                                    }}
                                >Atras</Button>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 6}} justifyContent={'flex-end'}>
                                <Button
                                    variant={'contained'}
                                    onClick={() => escogerFecha()}
                                >Confirmar</Button>
                            </Grid>

                        </Grid>


                    </TabPanel>

                </Grid>

            </TabContext>


        </Grid>
    )

}
export default Escoger_Fecha_Calendario_Cita

const arrSemana = [
    {
        "id": "Domingo",
        "am": false,
        "pm": false,
        "incioAm": "",
        "finAm": "",
        "incioPm": "",
        "finPm": ""
    }, {
        "id": "Lunes",
        "am": true,
        "pm": false,
        "incioAm": 8,
        "finAm": 12,
        "incioPm": "",
        "finPm": ""
    }, {
        "id": "Martes",
        "am": true,
        "pm": false,
        "incioAm": "",
        "finAm": "",
        "incioPm": "",
        "finPm": ""
    }, {
        "id": "Miercoles",
        "am": true,
        "pm": true,
        "incioAm": 8,
        "finAm": 12,
        "incioPm": 2,
        "finPm": 6
    }, {
        "id": "Jueves",
        "am": false,
        "pm": false,
        "incioAm": "",
        "finAm": "",
        "incioPm": "",
        "finPm": ""
    },
    {
        "id": "Viernes",
        "am": false,
        "pm": false,
        "incioAm": "",
        "finAm": "",
        "incioPm": "",
        "finPm": ""
    }, {
        "id": "Sabado",
        "am": false,
        "pm": false,
        "incioAm": "",
        "finAm": "",
        "incioPm": "",
        "finPm": ""
    },
]

const citasDia = [
    {
        fecha: new Date(2025, 4, 14, 8, 30).getTime()
    }
]